import { ref } from "vue";
import { defineStore } from "pinia";

export const useAccountStore = defineStore("account", () => {
  const resetPasswordSignatureFailed = ref(false);

  return {
    resetPasswordSignatureFailed,

    setResetPasswordSignatureFailed(value: boolean) {
      resetPasswordSignatureFailed.value = value;
    },
  };
});
